<div class="progress-bar">
  @let currentState = state();
  @let progress = progressValue();
  @let isDeterminate = mode() === progressBarModes.DETERMINATE;

  <div class="progress-bar__container">
    <div
      class="progress-bar__bar progress-bar__bar--{{ currentState }}"
      [ngClass]="{ 'progress-bar__bar--indeterminate': !isDeterminate }"
      [style.width]="isDeterminate ? progress + '%' : '50%'"></div>
  </div>

  <div class="progress-bar__progress">
    @if (currentState === 'error') {
      <evc-icon
        icon="close"
        size="xs"></evc-icon>
    } @else if (currentState === 'success' || progress === 100) {
      <evc-icon
        icon="check"
        size="xs"></evc-icon>
    } @else {
      <span>{{ progress }}%</span>
    }
  </div>
</div>
